import { render } from "./chartE.vue?vue&type=template&id=51ac65b9"
import script from "./chartE.vue?vue&type=script&lang=ts"
export * from "./chartE.vue?vue&type=script&lang=ts"
script.render = render

export default script